// DIGGII Balance Widget Component
import React from 'react';
import { motion } from 'framer-motion';
import { Coins, TrendingUp, ArrowRight, Sparkles } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Progress } from './ui/progress';

const DIGGII_LOGO = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";

const DiggiiBalance = ({ 
  balance = 0, 
  valorLocal = 0, 
  simbolo = 'Q',
  progresoSiguiente = 0,
  faltaParaSiguiente = 200,
  ratioAcumulacion = 200,
  showProgress = true,
  compact = false,
  onClick
}) => {
  const porcentajeProgreso = (progresoSiguiente / ratioAcumulacion) * 100;

  if (compact) {
    return (
      <motion.div
        whileHover={{ scale: 1.02 }}
        className="flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-amber-500/20 to-yellow-500/20 rounded-lg cursor-pointer border border-amber-500/30"
        onClick={onClick}
      >
        <Coins className="h-5 w-5 text-amber-500" />
        <span className="font-bold text-amber-600">{balance.toFixed(1)}</span>
        <span className="text-xs text-muted-foreground">DIGGII</span>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <Card className="overflow-hidden border-amber-500/30 bg-gradient-to-br from-amber-50 to-yellow-50 dark:from-amber-950/30 dark:to-yellow-950/30">
        <CardContent className="p-0">
          {/* Header con gradiente */}
          <div className="bg-gradient-to-r from-amber-500 to-yellow-500 p-4 text-white">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-sm">
                  <Coins className="h-6 w-6" />
                </div>
                <div>
                  <p className="text-sm opacity-90">Tu Balance DIGGII</p>
                  <p className="text-3xl font-bold">{balance.toFixed(2)}</p>
                </div>
              </div>
              <Sparkles className="h-8 w-8 opacity-50" />
            </div>
          </div>

          {/* Valor equivalente */}
          <div className="p-4 space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">Valor equivalente</p>
                <p className="text-xl font-semibold text-amber-600">
                  {simbolo}{valorLocal.toFixed(2)}
                </p>
              </div>
              <div className="text-right">
                <p className="text-xs text-muted-foreground">1 DIGGII = $1 USD</p>
                <p className="text-xs text-muted-foreground">= {simbolo}{(valorLocal / balance || 0).toFixed(2)}</p>
              </div>
            </div>

            {/* Progreso hacia siguiente DIGGII */}
            {showProgress && (
              <div className="space-y-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground">Próximo DIGGII</span>
                  <span className="font-medium text-amber-600">
                    ${progresoSiguiente.toFixed(2)} / ${ratioAcumulacion}
                  </span>
                </div>
                <Progress 
                  value={porcentajeProgreso} 
                  className="h-2 bg-amber-100"
                />
                <p className="text-xs text-muted-foreground text-center">
                  Te faltan <span className="font-medium text-amber-600">${faltaParaSiguiente.toFixed(2)} USD</span> para ganar 1 DIGGII
                </p>
              </div>
            )}

            {/* Call to action */}
            {onClick && (
              <button
                onClick={onClick}
                className="w-full flex items-center justify-center gap-2 py-2 text-sm font-medium text-amber-600 hover:text-amber-700 transition-colors"
              >
                Ver historial
                <ArrowRight className="h-4 w-4" />
              </button>
            )}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default DiggiiBalance;
